import React from 'react';
import { useSelector } from 'react-redux';
import { Popover } from '@material-ui/core';

import { CurrencyEnum } from '../../../../lib/enums/currency.enum';
import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store/index';
import { AvailableCashElement } from '../../../../lib/store/reporting/types';
import { getWalletTotalCalculatedCash } from '../../../../lib/store/selectors';
import { formatNumber } from '../../../../lib/util/DataHelpers';
import { CurrenciesSwitch } from '../../../../lib/util/types';

import IconEUR from '../../../../assets/img/wallet/icon-eu-flag.svg';
import IconTotal from '../../../../assets/img/wallet/icon-total-cash.svg';
import IconUS from '../../../../assets/img/wallet/icon-us-flag.svg';
import { ClickableDiv } from '../../../../components/index';

import styles from './CurrencyDropDown.module.scss';

type Props = {
    isOpen: boolean;
    anchorEl: HTMLElement | null;
    handleClose: () => void;
    chooseCurrency: (value: CurrenciesSwitch) => void;
}
const CurrencyDropDown = ({ isOpen, anchorEl, handleClose, chooseCurrency }: Props) => {
  const availableCash = useSelector<RootState, AvailableCashElement[]>(
    (state: RootState) => state.payment.availableCashInfo.availableCash[0].availableCashMultiCurrency,
  );
  const totalCash = useSelector<RootState, number>((state: RootState) => getWalletTotalCalculatedCash(state));
  const onCurrencySwitch = (val: CurrenciesSwitch) => {
    chooseCurrency(val);
    handleClose();
  };
  const renderPopupBody = () => availableCash.map((el: AvailableCashElement) => (
    <ClickableDiv
      key={el.currency}
      className={styles.rowPopup}
      onClick={() => onCurrencySwitch(el.currency as CurrenciesSwitch)}
    >
      <img src={el.currency === CurrencyEnum.USD ? IconUS : IconEUR} alt="county flag" />
      <span>{el.currency}</span>
      <span>{formatNumber(el.availableCash)}</span>
    </ClickableDiv>
  ));

  return (
    <Popover
      id={'dropdown-currency'}
      open={isOpen}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={handleClose}
      PaperProps={{
        style: {
          backgroundColor: '#1D3960',
          color: '#FDFFFF',
          border: '1px solid #3BB0FF',
          borderRadius: '2px',
          overflowY: 'hidden',
        },
      }}
    >
      <>
        {renderPopupBody()}
        <div className={styles.horizontalLine} />
        <ClickableDiv className={styles.totalValue} onClick={() => onCurrencySwitch('ALL')}>
          <img src={IconTotal} alt="total value icon" />
          <span>{lang.fundScreenTotalValue(CurrencyEnum.USD, formatNumber(totalCash))}</span>
        </ClickableDiv>
      </>
    </Popover>
  );
};
export default CurrencyDropDown;
